import React from 'react';

import { Box } from '@mui/material';

import { ChangeEmailForm, PasswordChangeRequest } from 'src/components/account';
import { DetailPageLayout } from 'src/components/common';
import { useScreenInfo } from 'src/hooks/common';
import { useCurrentUserPermissions } from 'src/hooks/user';

export const AccountSecurityPage: React.FC = () => {
  const { isMobile } = useScreenInfo();
  const { isEmployee } = useCurrentUserPermissions();

  const hasUserChangeEmailPermission = isEmployee;

  if (isMobile) {
    return (
      <React.Fragment>
        {!!hasUserChangeEmailPermission && (
          <Box pb={3}>
            <ChangeEmailForm />
          </Box>
        )}

        <Box>
          <PasswordChangeRequest />
        </Box>
      </React.Fragment>
    );
  }

  return (
    <DetailPageLayout titleContent="Sign-in & Security">
      {!!hasUserChangeEmailPermission && (
        <Box>
          <ChangeEmailForm />
        </Box>
      )}

      <Box paddingTop={3}>
        <PasswordChangeRequest />
      </Box>
    </DetailPageLayout>
  );
};
